import store from '../store/index';
import util from '../utils/util';
import queryParams from './pageQuery.service';
import * as queryValue from './query.const';
import { URLService } from '../services/url.service';
import homePoup from './homePoup';
import { clientIdentityService } from './intendedCar.service';
import {
  RedPacketPoup,
  RedPacketSharedTipPoup,
  RedPacketSharedPoup,
} from './homePoup/poup';
export default class RedPacketService {
  constructor(baseInfo) {
    this.baseInfo = baseInfo;
  }
  /**
   *获取siteId
   */
  getSiteId() {
    var siteId = 315;
    let from = queryParams.from;
    if (from) {
      if (from === 'znkcnew') {
        siteId = queryParams.siteId;
      } else if (from === 'cscz') {
        siteId = 328;
      }
    }
    return siteId;
  }
  /**
   *  获取frompvareaid参数字符串
   * @param {*} _pvareaid
   */
  getFromPvAreaIdStr(_pvareaid) {
    var _frompvareaid = queryParams.fromPvAreaId;
    if (!_frompvareaid) {
      _frompvareaid = _pvareaid;
    }
    _frompvareaid =
      _frompvareaid !== '' ? '&frompvareaid=' + _frompvareaid : '';
    return _frompvareaid;
  }
  /**
   * 获取pvareaid
   * @param {*} _pvareaid
   */
  getPvAreaId(_pvareaid) {
    var constPvareaid = 2594118; // 固定pvareaid
    constPvareaid = _pvareaid || constPvareaid;
    return constPvareaid;
  }
  getFrom() {
    var _from = queryParams.from;
    var constFrom = 'zhanting'; // 固定from参数
    if (_from) {
      constFrom = _from;
    }
    return constFrom;
  }
  buildRedPacketUrl(data) {
    var redpacketurls = '';
    let queryStr = this.buildRedPacketQueryParam();
    for (let i = 0; i < data.length; i++) {
      let item = data[i];
      if (item.checked) {
        i = data.length;
        redpacketurls = '';
      }
      let urlService = new URLService(item.landUrl);
      urlService.queryParams.remove('siteId');
      urlService.queryParams.remove('eid');
      urlService.queryParams.remove('busi');
      urlService.queryParams.remove('salesId');
      urlService.queryParams.append('busi', 'dealerVr');
      urlService.queryParams.append(
        'salesId',
        store.state.sales.salesInfo.salesId,
      );
      let landUrl = urlService.build();
      redpacketurls +=
        landUrl + queryStr + this.buildFragment(item.activityId) + '，';
    }
    redpacketurls = redpacketurls.substr(0, redpacketurls.length - 1);
    return redpacketurls;
  }
  buildRedPacketQueryParam() {
    let baseInfo = this.baseInfo;
    var dealerId = baseInfo.dealerId;
    let cityId = baseInfo.cityId;
    var _pvareaid = queryParams.pvAreaId;
    var _frompvareaid = this.getFromPvAreaIdStr(_pvareaid);
    var siteId = this.getSiteId();
    var constFrom = this.getFrom();
    _frompvareaid = '';
    let cityParamStr = '';
    if (cityId) {
      cityParamStr = '&cityid=' + cityId;
    }
    return `&dealerid=${dealerId}${cityParamStr}&siteid=${siteId}${_frompvareaid}&from=${constFrom}`;
  }
  buildFragment(activityId) {
    var _pvareaid = util.getUrlParam('pvareaid');
    var constPvareaid = this.getPvAreaId(_pvareaid);
    return `#pvareaid=${constPvareaid}${activityId ? '|' + activityId : ''}`;
  }
  bindRedpacket() {
    let self = this;
    if (queryParams.from === queryValue.QUERY_FROM_GDXIAOCHENGXU) {
      return Promise.resolve();
    }
    // 判断是否存在车惠买活动
    return store.dispatch('getFunctionData').finally(function () {
      return clientIdentityService
        .getClientId()
        .then((result) => {
          return store.dispatch('intended/getIntendRedpacket', {
            dealerId: store.state.baseInfo.dealerId,
            ...result,
          });
        })
        .then(function () {
          let intendRedPacket = store.state.intended.intendRedPacket;
          if (intendRedPacket) {
            self.openRedPacket(intendRedPacket);
          }
        });
    });
  }
  openRedPacket(intendRedPacket) {
    const salesInfo = store.state.sales.salesInfo;
    const salesId = salesInfo.salesId || 0;
    const dealerId = store.state.baseInfo.dealerId;
    const icsShowState = store.state.busiIcsApp.icsShowState;
    /**
     *  这些弹层互斥但是和开屏广告不互斥
     */
    const redPacketPoups = [
      new RedPacketSharedTipPoup(
        queryParams,
        intendRedPacket.redPacketList,
        salesId,
      ),
      new RedPacketSharedPoup(queryParams, intendRedPacket.redPacketList),
      new RedPacketPoup(queryParams, dealerId, intendRedPacket, icsShowState),
    ];
    homePoup.add(redPacketPoups);
  }
}
